
export default function withoutIndex<T>(array: T[], indexToRemove: number): T[] {
    return array.filter((_, n) => n !== indexToRemove);
}
